@if (placeholder !== undefined) {
  <div class="action-bar" #ActionBarContainer
    [style.top]="targetRegion.y + 'px'"
    [style.left]="targetRegion.x + 'px'"
    [style.width]="targetRegion.width + 'px'"
    [style.height]="targetRegion.height + 'px'"
    [style.transform]="'rotate(' + targetRegion.rotation + 'deg)'"
    [style.display]="display ? 'initial' : 'none'"
    [style.opacity]="triggersAreUseable ? '1.0' : '0.0'"
    >
    <div class="trigger-group"
      #triggersRef
      [ngStyle] = "{
      'left': triggerGroup.left,
      'top': triggerGroup.top,
      'transform': 'translate('
      + triggerGroup.alignHorizontal
      + ', '
      + triggerGroup.alignVertical
      + ')'
      }"
      >
      <div class="trigger-inner-wrapper"
        [style.flexDirection]="triggerGroup.direction">
        @for (trigger of triggerGroup.triggers; track $index) {
          <div
            class="trigger"
            (click)="triggerClicked(trigger.action)"
            >
            @if (trigger.icon.type === 'font') {
              <div>
                <mat-icon class="trigger-icon"
                  [style.transform]="'rotate(' + -targetRegion.rotation + 'deg)'"
                >{{trigger.icon.value}}</mat-icon>
              </div>
            }
            @if (trigger.icon.type === 'svg') {
              <div>
                <mat-icon class="trigger-icon" [svgIcon]="trigger.icon.value"
                  [style.transform]="'rotate(' + -targetRegion.rotation + 'deg)'"
                ></mat-icon>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
